// extracted by mini-css-extract-plugin
export default {"root":"SocialShare_root__wyJhw","iconButton":"SocialShare_iconButton__aC60r","disabled":"SocialShare_disabled__WDfE4","label":"SocialShare_label__PHeKp"};